import store from '../store'
import {Howl, Howler} from 'howler'

export function getCookie(name) {
    var cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

export function initSound(store) {
    let AudioContext = window.AudioContext || window.webkitAudioContext || false
    if (AudioContext) {
        let context = new AudioContext()
        if (context) {
            context.resume()
        }
    }

    // const base = store.state.config.assetsDir
    const base = '/static/bzuco_guard/mobile/'

    if (!store.$sound) {
        store.$sound = {
            ok: new Howl({
                src: [base + 'sound-ok.mp3']
            }),
            alarm: new Howl({
                src: [base + 'sound-alarm.mp3']
            }),
            check: new Howl({
                src: [base + 'sound-check.mp3']
            }),
        }
        Howler.volume(1.0)
    }
}